// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/servicos/delete/<id>
 *
 * Returns null `dados` on success — legacy shape emits an empty payload.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Servicos_DeleteResponseDados = null;

export type Servicos_DeleteResponse = ApiResponse<Servicos_DeleteResponseDados>;

registerResponseContract('Servicos_DeleteResponse', {})
